
      export const versions = {
        commit: 'f16fca8fabfb64d51efb47c5ffd1a44f0448746c',
        branch: 'HEAD'
      };
